<script lang="ts" setup>
import {
  ITirPmUserLoginRequest,
  ITirUserResponse,
} from "@/tir-pm-authenticator/src/interfaces";
import { TirPmAutentificatiorService } from "@/tir-pm-authenticator";
import { useRouter } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  UserIcon,
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";

import { computed, onBeforeMount, onMounted, ref } from "vue";
import { TirPmPlate } from "tir-pm-plate";
import { TirPmStatusBudge } from "tir-pm-status-budge";
import TypeRoles from "@/shared/api/Main/dataSource/api/users/implementation/TypeRoles";
import ApiService from "@/shared/api";
import { CurrentUser, CurrentUserModel, UserRoleEnum } from "tir-pm-user-core";
const api = new ApiService();
const router = useRouter();

/**
 *  Переменные для инпутов
 */
const login = ref("");
const password = ref("");

/**
 *  Переменные для показа инпутов и ошибки
 */
const showPassword = ref(false);
const showPlateWarning = ref(false);

const typePassword = computed(() => {
  return showPassword.value ? "text" : "password";
});

/**
 * Блок элемента контента
 */
const $currentComponentWrapper = ref(null);

/**
 * Текущая высота элемента контента
 */
const currentHeightComponent = ref(null);

/**
 * Перерасчет высоты
 */
const currentHeightLocalComputed = computed(() => {
  return currentHeightComponent.value;
});


/**
 * Лоадер для кнопки
 */
 const loadingRequest = ref(false)

/**
 * Перерасчет высоты
 */
 const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

const mapRole = (role: TypeRoles) => {
    return {
      [TypeRoles.Employee]: UserRoleEnum.Employee,
      [TypeRoles.Owner]: UserRoleEnum.Owner,
      [TypeRoles.NamespaceAdmin]: UserRoleEnum.NamespaceAdmin,
      [TypeRoles.ProjectAdmin]: UserRoleEnum.ProjectAdmin,
    }[role];
  }

/**
 *  Метод для автооризации
 */
const onLogin = async () => {
  loadingRequest.value = true
  try {
    let data = await api.Main.UsersService.loginAsync({
      Email: login.value,
      Password: password.value,
    });
    const userResp = await api.Main.UsersService.getCurrentUserAsync();
    CurrentUser.set(new CurrentUserModel({
      Id: userResp.Id,
      Email: userResp.Email,
      FirstName: userResp.FirstName,
      LastName: userResp.LastName,
      MiddleName: userResp.MiddleName,
      AvatarColor: userResp.AvatarColor,
      Foto: userResp.Foto,
      Roles: userResp.Roles.map(mapRole),
    }))
    showPlateWarning.value = false;
    router.push("/projects");
  } catch (error) {
    console.error(error);
    showPlateWarning.value = true;
    loadingRequest.value = false
  }
  setTimeout(() => {
    currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  });
};

onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

defineExpose({
  changerMethodFromComponent: onLogin,
  currentHeightComponent: currentHeightLocalComputed,
  isLoadingIntoComponent: loadingRequestComputed
});
</script>

<template>
  <div class="layout-login__body" ref="$currentComponentWrapper">
    <img class="layout-login__logo" src="../../assets/images/Logo.svg" alt="" />
    <div class="layout-login__wrap-input">
      <TirPmInput
        type="email"
        test="email"
        v-model="login"
        isAutocomplete
        label="Электронная почта"
        placeholder=""
        :isWithError="showPlateWarning"
        :isWithHint="false"
      >
        <template #leftInputAddons>
          <div class="layout-login__input-addons">
            <UserIcon></UserIcon>
          </div>
        </template>
      </TirPmInput>
      <TirPmInput
        isAutocomplete
        label="Пароль"
        test="password"
        :type="typePassword"
        v-model="password"
        placeholder=""
        :isWithHint="false"
        :isWithError="showPlateWarning"
      >
        <template #leftInputAddons>
          <div class="layout-login__input-addons">
            <KeyIcon></KeyIcon>
          </div>
        </template>
        <template #hintMessage></template>
        <template #rightInputAddons>
          <div
            class="layout-login__input-addons layout-login__input-addons--action"
            :class="{
              'layout-login__input-addons--show': password.length,
            }"
          >
            <EyeIcon
              @click="showPassword = !showPassword"
              v-if="!showPassword"
            ></EyeIcon>
            <EyeSlashIcon
              @click="showPassword = !showPassword"
              v-if="showPassword"
            ></EyeSlashIcon>
          </div>
        </template>
      </TirPmInput>
      <TirPmPlate :isShow="showPlateWarning" variant="negative" isRounded test="error-login-msg">
        <template #leftAddon>
          <TirPmStatusBudge status-color="negative" status-icon-type="alert" />
        </template>
        <template #text>
          Ошибка авторизации – неверное введение логина, пароля. <br />
          <RouterLink to="/restore-access" class="layout-login__linkto-other"
            >Восстановить доступ</RouterLink
          >
        </template>
      </TirPmPlate>
    </div>
  </div>
</template>
